export default {"src":"/_next/static/media/loading.9d7d2893.svg","height":101,"width":100,"blurWidth":0,"blurHeight":0};